import script from "./cardapio-restaurante.vue?vue&type=script&setup=true&lang=js"
export * from "./cardapio-restaurante.vue?vue&type=script&setup=true&lang=js"

import "./cardapio-restaurante.vue?vue&type=style&index=0&id=46ef7b76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ef7b76"]])

export default __exports__